<mat-dialog-content style="height: 50vh; display: flex; flex-direction: column">
  <mat-label>{{ 'ADMIN.extension_projects' | translate }}</mat-label>

  <app-items-search-wrapper>
    @for (project of projects; track project) {
      <app-search-option
        [label]="project.name"
        style="overflow: hidden; line-height: 35px">
        <mat-checkbox (change)="toggleProjectState($event, project)"
          [checked]="isEnabled(project)">
          <mat-label>{{ project.name }}</mat-label>
        </mat-checkbox>
      </app-search-option>
    }
  </app-items-search-wrapper>
</mat-dialog-content>

<app-button-group>
  <button [mat-dialog-close]="{ enabledProjects: this.data.enabledProjects }"
    color="primary"
    mat-raised-button>
    <mat-label>{{ 'COMMON.save' | translate }}</mat-label>
  </button>

  <button [mat-dialog-close] color="warn" mat-raised-button>
    <mat-icon style="margin-right: 5px;">close</mat-icon>
    <mat-label>{{ 'GOODS.CREATE.cancel_button' | translate }}</mat-label>
  </button>
</app-button-group>

<ng-template #item let-project>
  <div style="overflow: hidden; line-height: 35px">
    <mat-checkbox (change)="toggleProjectState($event, project)"
      [checked]="isEnabled(project)">
      <mat-label>{{ project.name }}</mat-label>
    </mat-checkbox>
  </div>
</ng-template>
